import {initializeApp} from "firebase/app"
import {getAuth,signInWithPopup,GoogleAuthProvider,signOut} from "firebase/auth"
import {getFirestore,getDocs,collection,setDoc,doc,serverTimestamp} from "firebase/firestore"
import {getStorage,uploadBytes,ref,getDownloadURL} from "firebase/storage"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
}
const app = initializeApp(firebaseConfig)

const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
//FirebaseAuth operations
export function signIn(){
  return new Promise(resolve=>
    signInWithPopup(auth,new GoogleAuthProvider())
    .then(response=>resolve(response.user))//user:provided by firebase
    .catch(console.error)
  )
}
export function logOut(){
  return new Promise(resolve=>
    signOut(auth)
    .then(()=>resolve())
    .catch(console.error)
  )
}
export function getCurrentUser(){
  return new Promise(resolve=>auth.onAuthStateChanged(resolve))//onAuthStateChanged: provided by firebase
}
//Firestore operations
export function readDocs(collectionName){
  const docs = []
  return new Promise(async resolve => {
    try {
      const snapshots = await getDocs(collection(db, collectionName))
      snapshots.forEach(doc => {
        const data = { ...doc.data(), id: doc.id }//data,id: provided by firebase
        docs.push(data)
      })
      resolve(docs)
    } 
    catch (e) {console.error(e)}
  })
}
export function writeDoc(inputs, collectionName){
  const randomID = Math.floor(Math.random() * 1000000000)
  return new Promise(async resolve => {
    try {
      await setDoc(doc(db,collectionName,`${randomID}`),{
        comment: inputs.comment,
        path: inputs.path,
        createdAt: serverTimestamp(),
        user: inputs.user
      })
      resolve('New doc successfully inserted')
    } 
    catch (e) {console.error(e)}
  })
}
//Storage operations
export function uploadFile(media){
  return new Promise(resolve => {
    try {
      uploadBytes(ref(storage,`images/${media.comment}`), media.file)
      .then(snapshot => resolve({ path: snapshot.metadata.fullPath, name: media.comment }))
      .catch(console.error)
    } 
    catch (e) {console.error(e)}
  })
}
export function downloadFile(media){
  return new Promise(async resolve => {
    try {
      resolve(await getDownloadURL(ref(storage, media.path)))
    } 
    catch (e) {console.error(e)}
  })
}
export default app